'use client'

import { Star } from 'lucide-react'
import { reviewCountLabel } from './reviewsFormat'

export type ReviewHubButtonProps = {
  average: number
  count: number
  open: boolean
  onClick: () => void
}

/**
 * Persistent floating trigger for the reviews hub. Two lines inside one quiet
 * pill: the rating, then the labeled count. The count is spelled out because
 * the prior one-line form ("★ 5.0 · 58") never said what the 58 was. The host
 * positions it (bottom-left column); this is just the control.
 * `aria-haspopup="dialog"` + `aria-expanded` tie it to the panel.
 */
export function ReviewHubButton({ average, count, open, onClick }: ReviewHubButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-haspopup="dialog"
      aria-expanded={open}
      aria-label={`Reviews: ${average.toFixed(1)} out of 5 from ${reviewCountLabel(count)}`}
      className="inline-flex flex-col items-start rounded-2xl border border-[var(--color-border)] bg-[var(--color-bg-primary)] px-4 py-2 text-left shadow-[0_8px_30px_rgba(0,0,0,0.12)] transition-transform hover:-translate-y-0.5"
    >
      <span
        className="inline-flex items-center gap-1.5 text-sm font-semibold text-[var(--color-text-primary)]"
        style={{ fontFamily: 'var(--font-heading)' }}
      >
        <Star
          className="size-4 shrink-0"
          style={{ color: 'var(--color-star, #fbbc05)', fill: 'var(--color-star, #fbbc05)' }}
          aria-hidden="true"
        />
        {average.toFixed(1)}
      </span>
      <span className="text-xs text-[var(--color-text-muted)]">{reviewCountLabel(count)}</span>
    </button>
  )
}
